<div class="message-container">
  <div class="header">
    <div class="sender">
      <span class="sender-label"><strong>FROM:</strong></span>
      <span class="sender-name"><strong>{{message().sender}}</strong></span>
    </div>
    @if (message().attachments.length > 0) {
      <button class="attachments"
        [appDropdownTriggerFor]="dropdownComponent"
        [attr.aria-label]="'Dropdown for ' + message().attachments.length + ' attachment' + ((message().attachments.length > 1) ? 's' : '')">
        <img class="attachments-paperclip" src="assets/icons/common/attachment.svg" alt="attachment">
        <span class="attachments-number">{{message().attachments.length}}</span>
        <img class="attachments-arrow" src="assets/icons/common/arrow-down.svg" alt="">
        <app-dropdown #dropdownComponent [arrowOffset]="1.6" [arrowBackgroundColour]="'arrow-white'">
          <div class="attachments-list">
            @for (attachment of message().attachments; track attachment) {
              <div class="attachment-row">
                <button type="button" class="attachment"
                  (click)="download(attachment)" [attr.aria-label]="'download ' + attachment.filename">
                  <img class="attachment__icon" src="{{attachment.iconUrl}}" alt=""/>
                  <p class="attachment__name">{{attachment.filename}}</p>
                </button>
                @if (message().isOwnMessage) {
                  <button type="button" class="attachment-delete"
                    [attr.aria-label]="'delete ' + attachment.filename"
                    (click)="deleteClicked(attachment, $event)">
                    <img src="assets/icons/common/remove.svg" alt="">
                  </button>
                }
              </div>
            }
          </div>
        </app-dropdown>
      </button>
    }
    @if (message().attachments.length > 0) {
      <div class="divider">|</div>
    }
    <div class="timestamp">{{message().timestamp}}</div>
  </div>
  <div class="message-content">{{message().content}}</div>
</div>
